import { useQuery } from '@tanstack/react-query';
import UserService from '../Services/users/UserService';
import AccountService from '../Services/users/AccountService';
import NotificationService from '../Services/users/NotificationService';
export const GET_USERS_QUERY_KEY = 'getUsers';
export const GET_ACCOUNT_DEVICES_QUERY_KEY = 'getAccountDevices';
export const GET_USER_PROGRESS_QUERY_KEY = 'getUserProgress';
export const GET_USER_FAVOURITES_QUERY_KEY = 'getUserFavourites';
export const GET_USER_ACTIVITY_DURATION_QUERY_KEY = 'getUserActivityDuration';
export const GET_WEEKLY_ACTIVITY_QUERY_KEY = 'getWeeklyActivity';
export const GET_LEARNING_STREAK_QUERY_KEY = 'getLearningStreak';
export const GET_NOTIFICATIONS_QUERY_KEY = 'getNotifications'; 
//TODO: to change to use GroupedHook Export Pattern instead of Individual Hook Export Pattern
export const useGetUsers = () => {
  return useQuery({
    queryKey: [GET_USERS_QUERY_KEY],
    queryFn: UserService.getAllUsers,
  });
};

export const useGetAccountDevices = (enabled) => {
  return useQuery({
    queryKey: [GET_ACCOUNT_DEVICES_QUERY_KEY],
    queryFn: AccountService.getAccountDevices,
    enabled: !!enabled, //? Enable the query only when the enabled flag is true
    staleTime: 24 * 60 * 60 * 1000, 
    cacheTime: 48 * 60 * 60 * 1000, 
  });
};

export const useGetUserProgress = () => {
  return useQuery({
    queryKey: [GET_USER_PROGRESS_QUERY_KEY],
    queryFn: AccountService.getUserProgress,
    staleTime: 24 * 60 * 60 * 1000,
    cacheTime: 48 * 60 * 60 * 1000,
  });
};

export const useGetFavouritesQuery = () => {
  return useQuery({
    queryKey: [GET_USER_FAVOURITES_QUERY_KEY],
    queryFn: AccountService.getUserFavourites,
    staleTime: 24 * 60 * 60 * 1000,
    cacheTime: 48 * 60 * 60 * 1000,
  });
};

export const useGetWeeklyActivity = (startDate) => {
  return useQuery({
    queryKey: [GET_WEEKLY_ACTIVITY_QUERY_KEY, startDate],
    queryFn: () => AccountService.getWeeklyActivity(startDate),
    staleTime: 24 * 60 * 60 * 1000,
    cacheTime: 48 * 60 * 60 * 1000,
  });
};

export const useGetLearningStreak = () => {
  return useQuery({
    queryKey: [GET_LEARNING_STREAK_QUERY_KEY],
    queryFn: AccountService.getLearningStreak,
    staleTime: 24 * 60 * 60 * 1000,
    cacheTime: 48 * 60 * 60 * 1000,
  });
};

export const useGetNotifications = () => { 
  return useQuery({
    queryKey: [GET_NOTIFICATIONS_QUERY_KEY],
    queryFn: NotificationService.getNotifications,
    staleTime: 5 * 60 * 1000, // 5 minutes - shorter for notifications
    cacheTime: 30 * 60 * 1000, // 30 minutes - notifications should be relatively fresh
    refetchOnWindowFocus: false, // Prevent refetch when window regains focus
    refetchOnMount: false, // Use cached data when component remounts
  });
};